<template>
  <div>
    <IndexNavbar />
    <main>
      <!-- HEADER SECTION -->
      <section class="pb-20 relative block bg-blueGray-800">
        <div class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20">
          <svg class="absolute bottom-0 overflow-hidden" xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
            <polygon class="text-blueGray-800 fill-current" points="2560 0 2560 100 0 100"></polygon>
          </svg>
        </div>

        <div class="container mx-auto px-4 lg:pt-24 lg:pb-64">
          <div class="flex flex-wrap text-center justify-center">
            <div class="w-full lg:w-6/12 px-4">
              <h2 class="text-4xl font-semibold text-white">Drop Us A Line</h2>
              <p class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-400">
                You can reach us via email or phone. We are available from
                Monday to Friday, 9am to 6pm.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- CONTACT FORM SECTION -->
      <section class="relative block py-24 lg:pt-0 bg-blueGray-800">
        <div class="container mx-auto px-4">
          <div class="flex flex-wrap justify-center lg:-mt-64 -mt-48">
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200">
                <div class="flex-auto p-5 lg:p-10">
                  <h4 class="text-2xl font-semibold">Want to work with us?</h4>
                  <p class="leading-relaxed mt-1 mb-4 text-blueGray-500">
                    Complete this form and we will get back to you in 24 hours.
                  </p>

                  <!-- Success/Error Messages -->
                  <div v-if="successMessage" class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
                    {{ successMessage }}
                  </div>
                  <div v-if="errorMessage" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                    {{ errorMessage }}
                  </div>

                  <form @submit.prevent="submitForm">
                    <!-- FULL NAME -->
                    <div class="relative w-full mb-3 mt-8">
                      <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                        Full Name <span class="text-red-500">*</span>
                      </label>
                      <input v-model="form.fullName" type="text"
                        class="border-0 px-3 py-3 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                        placeholder="Full Name" required />
                    </div>

                    <!-- EMAIL -->
                    <div class="relative w-full mb-3">
                      <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                        Email <span class="text-red-500">*</span>
                      </label>
                      <input v-model="form.email" type="email"
                        class="border-0 px-3 py-3 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                        placeholder="Email" required />
                    </div>

                    <!-- PHONE -->
                    <div class="relative w-full mb-3">
                      <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                        Phone <span class="text-red-500">*</span>
                      </label>
                      <input v-model="form.phone" type="tel"
                        class="border-0 px-3 py-3 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                        placeholder="Phone Number" required />
                    </div>

                    <!-- ORGANIZATION -->
                    <div class="relative w-full mb-3">
                      <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                        Name of Organization
                      </label>
                      <input v-model="form.organization" type="text"
                        class="border-0 px-3 py-3 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                        placeholder="Name of Organization" />
                    </div>

                    <!-- DESIGNATION -->
                    <div class="relative w-full mb-3">
                      <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                        Designation
                      </label>
                      <input v-model="form.designation" type="text"
                        class="border-0 px-3 py-3 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                        placeholder="Designation" />
                    </div>

                    <!-- SECTOR -->
                    <div class="relative w-full mb-3">
                      <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                        Select Sector
                      </label>
                      <select v-model="form.sector"
                        class="border-0 px-3 py-3 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full">
                        <option value="">Select Sector</option>
                        <option>Manufacturing</option>
                        <option>Transport</option>
                        <option>Technology</option>
                        <option>Energy</option>
                        <option>Other</option>
                      </select>
                    </div>

                    <!-- MESSAGE -->
                    <div class="relative w-full mb-3">
                      <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                        Message <span class="text-red-500">*</span>
                      </label>
                      <textarea v-model="form.message" rows="4"
                        class="border-0 px-3 py-3 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                        placeholder="Type a message..." required></textarea>
                    </div>

                    <!-- SUBMIT BUTTON -->
                    <div class="text-center mt-6">
                      <button type="submit" :disabled="sending"
                        class="bg-blueGray-800 text-white text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg transition-all duration-150 disabled:opacity-50">
                        {{ sending ? 'Sending...' : 'Send Email' }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer-component />
  </div>
</template>

<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import axios from 'axios';

export default {
  components: { IndexNavbar, FooterComponent },
  
  data() {
    return {
      form: {
        fullName: "",
        email: "",
        phone: "",
        organization: "",
        designation: "",
        sector: "",
        message: "",
      },
      sending: false,
      successMessage: "",
      errorMessage: "",
    };
  },

  methods: {
    generateEmailHTML() {
      return `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; margin: 0; padding: 0; background-color: #f4f7fc; }
            .container { max-width: 600px; margin: 20px auto; background: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.08); }
            .header { background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%); padding: 40px 30px; text-align: center; }
            .header h1 { color: #ffffff; margin: 0; font-size: 28px; font-weight: 600; letter-spacing: 1px; }
            .header p { color: #a8b2d1; margin: 10px 0 0; font-size: 16px; }
            .content { padding: 40px 35px; }
            .greeting { font-size: 18px; color: #1a1a2e; margin-bottom: 25px; }
            .greeting strong { color: #0f3460; }
            .info-grid { background: #f8fafc; border-radius: 8px; padding: 20px; margin-bottom: 25px; border-left: 4px solid #0f3460; }
            .info-row { display: flex; padding: 8px 0; border-bottom: 1px solid #e8edf3; }
            .info-row:last-child { border-bottom: none; }
            .info-label { font-weight: 600; color: #1a1a2e; width: 130px; flex-shrink: 0; font-size: 14px; }
            .info-value { color: #2d3748; font-size: 14px; }
            .message-box { background: #ffffff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 20px; margin: 20px 0; }
            .message-box h3 { margin: 0 0 10px; color: #1a1a2e; font-size: 16px; }
            .message-box p { margin: 0; color: #4a5568; line-height: 1.6; }
            .badge { display: inline-block; background: #e2e8f0; padding: 4px 12px; border-radius: 20px; font-size: 12px; color: #2d3748; }
            .footer { background: #f8fafc; padding: 25px 30px; text-align: center; border-top: 1px solid #e2e8f0; }
            .footer p { margin: 0; color: #718096; font-size: 14px; }
            .footer .company { color: #0f3460; font-weight: 600; }
            @media only screen and (max-width: 480px) {
              .container { margin: 10px; }
              .content { padding: 25px 20px; }
              .header { padding: 30px 20px; }
              .info-row { flex-direction: column; padding: 12px 0; }
              .info-label { width: 100%; margin-bottom: 4px; }
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <h1>📬 New Contact Form Submission</h1>
              <p>You have received a new inquiry from your website</p>
            </div>
            
            <div class="content">
              <div class="greeting">
                Hello Team,<br>
                You have received a new contact request from <strong>${this.form.fullName}</strong>.
              </div>
              
              <div class="info-grid">
                <div class="info-row">
                  <span class="info-label">👤 Full Name</span>
                  <span class="info-value">${this.form.fullName}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">✉️ Email</span>
                  <span class="info-value">${this.form.email}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">📞 Phone</span>
                  <span class="info-value">${this.form.phone}</span>
                </div>
                ${this.form.organization ? `
                <div class="info-row">
                  <span class="info-label">🏢 Organization</span>
                  <span class="info-value">${this.form.organization}</span>
                </div>
                ` : ''}
                ${this.form.designation ? `
                <div class="info-row">
                  <span class="info-label">💼 Designation</span>
                  <span class="info-value">${this.form.designation}</span>
                </div>
                ` : ''}
                ${this.form.sector ? `
                <div class="info-row">
                  <span class="info-label">🏭 Sector</span>
                  <span class="info-value"><span class="badge">${this.form.sector}</span></span>
                </div>
                ` : ''}
              </div>
              
              <div class="message-box">
                <h3>💬 Message</h3>
                <p>${this.form.message}</p>
              </div>
              
              <div style="background: #ebf8ff; border-radius: 8px; padding: 15px; border: 1px solid #bee3f8; margin-top: 20px;">
                <p style="margin: 0; color: #2c5282; font-size: 13px;">
                  ⏰ This inquiry was sent on ${new Date().toLocaleString('en-US', { 
                    weekday: 'long', 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
              </div>
            </div>
            
            <div class="footer">
              <p>
                <span class="company">Your Company Name</span><br>
                This email was sent from your website contact form.
              </p>
            </div>
          </div>
        </body>
        </html>
      `;
    },

    async submitForm() {
      this.sending = true;
      this.successMessage = "";
      this.errorMessage = "";

      try {
        const response = await axios.post('https://formsubmit.co/ajax/Jayant@ameisetec.com', {
          name: this.form.fullName,
          email: this.form.email,
          phone: this.form.phone,
          organization: this.form.organization || 'Not provided',
          designation: this.form.designation || 'Not provided',
          sector: this.form.sector || 'Not specified',
          message: this.form.message,
          _subject: `New Contact Form Submission from ${this.form.fullName}`,
          _captcha: false,
          _template: 'table', // This makes it look better
          _autoresponse: 'Thank you for contacting us! We will get back to you within 24 hours.',
          _autoresponsefrom: 'sushila@ameisetec.com',
        });

        if (response.data.success) {
          this.successMessage = "Email sent successfully! We'll get back to you within 24 hours.";
          this.resetForm();
        }
      } catch (error) {
        this.errorMessage = "Failed to send email. Please try again.";
        console.error('Error:', error);
      } finally {
        this.sending = false;
      }
    },

    resetForm() {
      this.form = {
        fullName: "",
        email: "",
        phone: "",
        organization: "",
        designation: "",
        sector: "",
        message: "",
      };
      setTimeout(() => {
        this.successMessage = "";
      }, 5000);
    }
  }
};
</script>